import Profile from "./Profile"

export default  Profile;



// WEBPACK FOOTER //
// ./src/components/App/Profile/index.js